import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  IconButton,
  Input,
  Tooltip,
  Typography,
} from '@material-tailwind/react';
import { getCookie } from '../../../../utils/helper';
import { useEffect, useRef, useState } from 'react';
import {
  addStreets,
  listAllStreets,
  listCountAllStreets,
  listIdStreets,
  listStreetsLike,
  listStreetsWhere,
  removeStreets,
  updateStreets,
} from '../../../../services/apiCategory';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/solid';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const TABLE_HEAD = ['Đường/Thôn', 'Xã/Phường', 'Huyện/Thành Phố', 'Tỉnh', ''];

export default function Streets() {
  const auth = getCookie('token');
  const [resultList, setResultList] = useState([]);
  const [arrDefault, setArrDefault] = useState({ id_user: auth?.id, duong: '', xa: '', huyen: '', tinh: '' });
  const [isDisabled, setIsDisabled] = useState(false);
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState('');
  const [duong, setDuong] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [page, setPage] = useState(1);
  const [countDefault, setCountDefault] = useState(0);
  const [checkInfo, setCheckInfo] = useState(false);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const idCate = urlParams.get('u');
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const [inputDiaDiem, setInputDiaDiem] = useState({
    duong: arrDefault?.duong || '',
    xa: arrDefault?.xa || '',
    huyen: arrDefault?.huyen || '',
    tinh: arrDefault?.tinh || '',
  });

  const [resulDiaDiem, setResulDiaDiem] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const listAll = async (pages = 1) => {
    const resultAPI = await listAllStreets(pages);
    if (resultAPI.length > 0) {
      setResultList(resultAPI);
      const count = await listCountAllStreets();
      setCountDefault(count.totalRows);
    }
  };

  useEffect(() => {
    document.title = 'Danh mục địa điểm';
    listAll(1);
  }, []);

  useEffect(() => {
    getListID(idCate);
  }, [idCate]);

  const getListID = async (id) => {
    if (id) {
      const resultID = await listIdStreets(idCate);
      if (resultID.length > 0) {
        setCheckInfo(true);
        setArrDefault({
          id_user: auth?.id,
          duong: resultID[0].duong,
          xa: resultID[0].xa,
          huyen: resultID[0].huyen,
          tinh: resultID[0].tinh,
        });
      } else {
        setCheckInfo(false);
      }
    }
  };

  const changeValueAdmin = (jsonVL) => {
    setArrDefault({ ...arrDefault, ...jsonVL });
  };

  const subSreach = async (duong = '') => {
    if (duong) {
      const resultAPI = await listStreetsLike(duong);
      if (resultAPI.length > 0) {
        setResultList(resultAPI);
        setCountDefault(resultAPI.length);
      } else {
        setResultList([]);
        setCountDefault(0);
      }
    } else {
      await listAll();
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (inputDiaDiem.duong || inputDiaDiem.xa || inputDiaDiem.huyen || inputDiaDiem.tinh) {
        sreachDiaDiem(inputDiaDiem.duong, inputDiaDiem.xa, inputDiaDiem.huyen, inputDiaDiem.tinh);
      } else {
        setResulDiaDiem([]);
        setShowDropdown(false);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [inputDiaDiem]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const sreachDiaDiem = async (duong = '', xa = '', huyen = '', tinh = '') => {
    try {
      const resultAPI = await listStreetsLike(duong, xa, huyen, tinh);

      if (resultAPI?.length > 0) {
        setResulDiaDiem(resultAPI);
        setShowDropdown(true);
      } else {
        setResulDiaDiem([]);
        setShowDropdown(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSelectDiaDiem = (item) => {
    const newValue = {
      duong: item.duong || '',
      xa: item.xa || '',
      huyen: item.huyen || '',
      tinh: item.tinh || '',
    };

    setInputDiaDiem(newValue);
    changeValueAdmin(newValue);

    // Tắt dropdown NGAY
    setShowDropdown(false);
    setResulDiaDiem([]);
  };

  const subAddDefault = async () => {
    if (arrDefault?.duong === '' || arrDefault?.xa === '' || arrDefault?.huyen === '' || arrDefault?.tinh === '') {
      setMessageError(
        'Bạn nhập thiếu thông tin. Hãy nhập đầy đủ \n (Viết Hoa Chữ Cái Đầu -> ví dụ: Lý Nam Đế - Trần Khánh Dư)',
      );
    } else {
      const checkTrung = await listStreetsWhere(arrDefault?.duong, arrDefault?.xa, arrDefault?.huyen, arrDefault?.tinh);
      if (checkTrung?.length > 0) {
        setMessageError('Thông tin này đã có trong hệ thống');
      } else {
        setMessageError('');
        setIsDisabled(true);
        const resultAPI = await addStreets(arrDefault);
        if (resultAPI.message === 'OK') {
          setIsDisabled(false);
          listAll(1);
          setMessage('Thành Công');
          setOpenAlert(true);
          setArrDefault({ id_user: auth?.id, duong: '', xa: '', huyen: '', tinh: '' });
        } else {
          setIsDisabled(false);
          setMessage('Thất Bại');
          setOpenAlert(true);
        }
      }
    }
  };
  const subUpdateDefault = async () => {
    if (arrDefault?.duong === '' || arrDefault?.xa === '' || arrDefault?.huyen === '' || arrDefault?.tinh === '') {
      setMessageError(
        'Bạn nhập thiếu thông tin. Hãy nhập đầy đủ \n (Viết Hoa Chữ Cái Đầu -> ví dụ: Lý Nam Đế - Trần Khánh Dư)',
      );
    } else {
      setMessageError('');
      setIsDisabled(true);
      const body = {
        id: idCate,
        data: arrDefault,
      };
      const resultAPI = await updateStreets(body);
      if (resultAPI.message === 'OK') {
        setIsDisabled(false);
        listAll(1);
        navigate('/diadiem');
        setMessage('Thành Công');
        setOpenAlert(true);
        setArrDefault({ id_user: auth?.id, duong: '', xa: '', huyen: '', tinh: '' });
        setCheckInfo(false);
      } else {
        setIsDisabled(false);
        setMessage('Thất Bại');
        setOpenAlert(true);
      }
    }
  };

  const alertRemove = async (id) => {
    if (window.confirm(`Bạn đã chắc chắn XÓA dữ liệu này?`)) {
      // Save it!
      const body = {
        id: id,
      };
      const resultAPI = await removeStreets(body);
      if (resultAPI?.message === 'OK') {
        listAll(1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const nextPage = () => {
    const total = Math.ceil(countDefault / 50);
    if (total > page) {
      setPage(page + 1);
      listAll(page + 1);
    }
  };

  const prevPage = () => {
    const total = Math.ceil(countDefault / 50);
    if (total <= page && page > 1) {
      setPage(page - 1);
      listAll(page - 1);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div>
        <Card className="p-2">
          <h3 className="font-bold mb-1">THÊM ĐỊA ĐIỂM MỚI</h3>
          <Alert
            color={message === 'Thành Công' ? 'green' : 'red'}
            className="mb-2"
            open={openAlert}
            onClose={() => setOpenAlert(false)}
          >
            {message === 'Thành Công' ? 'Cập Nhật Thành Công' : 'Cập Nhật Thất Bại'}
          </Alert>

          <div ref={wrapperRef} className="relative">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <Input
                value={inputDiaDiem.duong}
                label="Tên Đường/Thôn"
                placeholder="Nhập tên đường/thôn"
                required
                onChange={(e) => {
                  const value = e.target.value;
                  setInputDiaDiem((prev) => ({ ...prev, duong: value }));
                  changeValueAdmin({ duong: value });
                }}
                onFocus={() => {
                  if (resulDiaDiem.length > 0) setShowDropdown(true);
                }}
              />

              <Input
                value={inputDiaDiem.xa}
                label="Tên Xã/Phường (cũ)"
                placeholder="Nhập tên xã/phường"
                required
                onChange={(e) => {
                  const value = e.target.value;
                  setInputDiaDiem((prev) => ({ ...prev, xa: value }));
                  changeValueAdmin({ xa: value });
                }}
                onFocus={() => {
                  if (resulDiaDiem.length > 0) setShowDropdown(true);
                }}
              />

              <Input
                value={inputDiaDiem.huyen}
                label="Tên Huyện/Thành Phố"
                placeholder="Nhập tên huyện/thành phố"
                required
                onChange={(e) => {
                  const value = e.target.value;
                  setInputDiaDiem((prev) => ({ ...prev, huyen: value }));
                  changeValueAdmin({ huyen: value });
                }}
                onFocus={() => {
                  if (resulDiaDiem.length > 0) setShowDropdown(true);
                }}
              />

              <Input
                value={inputDiaDiem.tinh}
                label="Tên Tỉnh"
                placeholder="Nhập tên tỉnh"
                required
                onChange={(e) => {
                  const value = e.target.value;
                  setInputDiaDiem((prev) => ({ ...prev, tinh: value }));
                  changeValueAdmin({ tinh: value });
                }}
                onFocus={() => {
                  if (resulDiaDiem.length > 0) setShowDropdown(true);
                }}
              />
            </div>

            {/* DROPDOWN */}
            {showDropdown && resulDiaDiem.length > 0 && (
              <div className="absolute z-50 bg-white border w-full max-h-72 overflow-auto shadow-lg rounded-md mt-2">
                {resulDiaDiem.map((item, index) => (
                  <div
                    key={index}
                    className="p-3 hover:bg-gray-100 cursor-pointer text-sm"
                    onClick={() => handleSelectDiaDiem(item)}
                  >
                    <div className="font-semibold">{item.duong}</div>
                    <div className="text-gray-600">
                      {item.xa} - {item.huyen} - {item.tinh}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {messageError && <b className="text-red-500"> {messageError}</b>}
          <Button
            className="bg-gradient-to-r from-orange-400 to-orange-900 mt-2"
            onClick={checkInfo ? subUpdateDefault : subAddDefault}
            disabled={isDisabled}
          >
            {checkInfo ? 'CẬP NHẬT' : 'LƯU THÊM MỚI'}
          </Button>

          <p className="text-red-500 font-bold">
            Lưu ý: Nhập viết chữ hoa đầu và không ghi chữ thừa như Xã hoặc Huyện: ví dụ Huyện Lâm Hà {`->`} Lâm Hà, Xã
            Gia Lâm {`->`} Gia Lâm ( chỉ ghi Phường nếu là số: Ví dụ Phường 1, Phường 2)
          </p>
        </Card>
      </div>
      <div>
        <Card className="h-full w-full">
          <CardBody className="overflow-auto px-0 p-1 rounded-3xl">
            <div className="flex flex-row gap-2 mt-1 mb-1">
              <Input
                value={duong}
                label="Tìm tên đường"
                placeholder="Nhập tên đường"
                required
                onChange={(e) => {
                  setDuong(e.target.value);
                }}
              />
              <Button className="text-nowrap" color="green" size="sm" onClick={() => subSreach(duong)}>
                TÌM KIẾM
              </Button>
            </div>
            <table className="w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                      <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {resultList.length > 0 &&
                  resultList.map((row, index) => {
                    const isLast = index === resultList.length - 1;
                    const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                    return (
                      <tr key={index}>
                        <td className={classes}>
                          <Typography variant="small" color="blue-gray" className="font-normal">
                            {row.duong}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography variant="small" color="blue-gray" className="font-normal">
                            {row.xa}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography variant="small" color="blue-gray" className="font-normal">
                            {row.huyen}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography variant="small" color="blue-gray" className="font-normal">
                            {row.tinh}
                          </Typography>
                        </td>
                        {row.duong && (
                          <td className={classes}>
                            <Tooltip content="Sửa">
                              <Link to={`/diadiem?u=${row.id}`}>
                                <IconButton variant="text">
                                  <PencilIcon className="h-4 w-4" />
                                </IconButton>
                              </Link>
                            </Tooltip>

                            <Tooltip content={`Xóa`}>
                              <IconButton variant="text" onClick={() => alertRemove(row.id)}>
                                <TrashIcon className={`h-4 w-4 text-red-500`} />
                              </IconButton>
                            </Tooltip>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </CardBody>
          {Math.ceil(countDefault / 50) > page && (
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Typography variant="small" color="blue-gray" className="font-normal">
                Page {page} of {Math.ceil(countDefault / 50)}
              </Typography>
              <div className="flex gap-2">
                <Button variant="outlined" size="sm" onClick={prevPage}>
                  Trang Trước
                </Button>
                <Button variant="outlined" size="sm" onClick={nextPage}>
                  Trang Tiếp
                </Button>
              </div>
            </CardFooter>
          )}
        </Card>
      </div>
    </div>
  );
}
